export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.21-2042.37",
  commitId: "829a43fd9eab1d3d6c662555ba5e152c33628c83",
  commitTime: "2026-04-21T20:42:37.000Z",
});
